import ItemMovement from "gantt-schedule-timeline-calendar/dist/ItemMovement.plugin.js";

export default [
  ItemMovement({
    moveable: true,
    resizeable: false,
    resizerContent: "",
    ghostNode: false,
    collisionDetection: true,
    wait: 200 /* Tempo de espera antes de começar a arrastar, deve ser mudado junto com a action de click*/,
  }),
];
